var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.15625 16.9474H20.5625V15.7368H1.875V0H0.4375V16.3421L1.15625 16.9474ZM3.3125 13.9211V4.23684L4.03125 3.63158H6.90625L7.625 4.23684V13.9211L6.90625 14.5263H4.03125L3.3125 13.9211ZM6.1875 13.3158V4.84211H4.75V13.3158H6.1875ZM14.8125 1.81579V13.9211L15.5312 14.5263H18.4062L19.125 13.9211V1.81579L18.4062 1.21053H15.5312L14.8125 1.81579ZM17.6875 2.42105V13.3158H16.25V2.42105H17.6875ZM9.0625 13.9211V6.6579L9.78125 6.05263H12.6562L13.375 6.6579V13.9211L12.6562 14.5263H9.78125L9.0625 13.9211ZM11.9375 13.3158V7.26316H10.5V13.3158H11.9375Z",
    fill: "#EA5455"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graph-icon.fc907b0e2287b170ed5060ef0e467156.svg";
export { ForwardRef as ReactComponent };